module.exports = __webpack_public_path__ + "static/media/image-gallery.7740e7b1.scss";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-image-gallery/styles/scss/image-gallery.scss
// module id = 736
// module chunks = 1